import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';
import styles from './unstyled-button.module.scss';
import clsx from 'clsx';

interface UnstyledButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

export const UnstyledButton = forwardRef<HTMLButtonElement, UnstyledButtonProps>(({ children, ...props }, ref) => {
  return (
    <button ref={ref} {...props} className={clsx(styles.button, props.className && props.className)}>
      {children}
    </button>
  );
});

UnstyledButton.displayName = 'UnstyledButton';
